import { lazy } from "react";
import { Route } from "react-router-dom";

const CertificationManagementPreferences = lazy(() => import("./certification/CertificationManagementPreferences"))
const CertTypeSettings = lazy(() => import("./certification/CertTypeSettings"))
const CertSubTypeSettings = lazy(() => import("./certification/CertSubTypeSettings"))
const CertFileTypeSettings = lazy(() => import("./certification/CertFileTypeSettings"))
const FileTypeAssignmentEditSettings = lazy(() => import("./certification/FileTypeAssignmentEditSettings"))
const FileTypeAssignmentListSettings = lazy(() => import("./certification/FileTypeAssignmentListSettings"))

const diversityOrganizationsRoutes =
<>

    <Route path="diversity-organizations/settings/certifications" element={<CertificationManagementPreferences />} />
    <Route path="diversity-organizations/settings/cert-types" element={<CertTypeSettings />} />
    <Route path="diversity-organizations/settings/cert-subtypes" element={<CertSubTypeSettings />} />
    <Route path="diversity-organizations/settings/cert-file-types" element={<CertFileTypeSettings />} />
    <Route path="diversity-organizations/settings/cert-file-type-assignments-edit" element={<FileTypeAssignmentEditSettings />} />
    <Route path="diversity-organizations/settings/cert-file-type-assignments-list" element={<FileTypeAssignmentListSettings />} />

</>

export default diversityOrganizationsRoutes;